import React, {useEffect, useState} from 'react';


interface IComponentProps {
  value:any;
  enums: any;
  nameSpace: string;
}
const EnumValueToText: React.FC<IComponentProps> = (props) => {
  const { nameSpace, enums, value } = props
  const [text, setText] = useState('');

  useEffect(() => {
    const list = enums?.[nameSpace] || [];
    const enymText = list?.find((item: any) => item.key === value)?.value;
    setText(enymText || '')
  }, [props]);

  return (
    <>{text}</>
  );
};

export default EnumValueToText;